import { Route, Routes } from "react-router-dom";

// CORREÇÃO DEFINITIVA: Adicionando a extensão .js em todas as importações.
// Isso resolve o erro "Could not resolve" quando o compilador não consegue 
// inferir a extensão do arquivo no ambiente atual.
import PaginaBase from "./pages/HomePage";
import AboutUsPage from "./pages/AboutUs";
import WirePage from "./pages/wireCapabilitiesPage";
import WireTestPage from "./pages/WireTestCapabilitiesPage";
import WeldingsPage from "./pages/WeldingsPage";
import ProductPage from "./pages/ProductPage";
import ContactUsPage from "./pages/ContactUsPage";
import CustomersPage from "./pages/CustomersPage";
import DenunciasPage from "./pages/DenunciasPage";
import InjecaoPlasticoPage from "./pages/InjecaoPlastico";

function AppRoutes() {
    return (
        // O <BrowserRouter> permanece REMOVIDO para corrigir o erro inicial do <Link>.
        <Routes>
            <Route path="/" element={<PaginaBase />} />
            <Route path="/Denuncia" element={<DenunciasPage />} />
            <Route path="/AboutUs" element={<AboutUsPage />} />
            <Route path="/Capabilities/Production" element={<ProductPage />} />
            <Route path="/ContactUs" element={<ContactUsPage />} />
            <Route path="/Capabilities/Production/Wires" element={<WirePage />} />
            <Route path="/Capabilities/Production/WireChecks" element={<WireTestPage />} />
            <Route path="/Capabilities/Production/Weldings" element={<WeldingsPage />} />
            <Route path="/Customers" element={<CustomersPage />} />
            <Route path="/Capabilities/Production/InjecaoPlastico" element={<InjecaoPlasticoPage />} />

        </Routes>
    );
}

export default AppRoutes;